export default {

    all: state => Object.values(state.entities),

    byId: state => id => {
        return state.entities[id]
    }

}


